var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_setup.name))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/organizations/workspaces/manage/${_setup.id}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-sm",
              on: { click: _setup.handleDeleteWorkspaceCommandV1 },
            },
            [
              _c("i", {
                staticClass: "fa fa-remove",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Delete this workspace")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "Name" } }, [_vm._v("Name:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.name,
                expression: "name",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Name of workspace" },
            domProps: { value: _setup.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.name = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "Name", errors: _setup.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "Description" } }, [
            _vm._v("Description:"),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.description,
                expression: "description",
              },
            ],
            staticClass: "form-control",
            attrs: { placeholder: "Description of workspace" },
            domProps: { value: _setup.description },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.description = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "Description", errors: _setup.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "StartupUrl" } }, [
            _vm._v("Startup url:"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _setup.startupUrl,
                expression: "startupUrl",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Startup url - only for advanced scenarios",
            },
            domProps: { value: _setup.startupUrl },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _setup.startupUrl = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "StartupUrl", errors: _setup.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_setup.invoking,
              expression: "!invoking",
            },
          ],
          staticClass: "btn btn-primary btn-lg",
          attrs: { type: "button" },
          on: { click: _setup.invokeUpdateWorkspaceCommandV1 },
        },
        [_vm._v("Update")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _setup.invoking,
              expression: "invoking",
            },
          ],
          staticClass: "btn btn-primary btn-lg",
          attrs: { type: "button" },
        },
        [_vm._v("Updating...")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }